var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/34px/Apps/OneLogin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/34px/Apps/OneLogin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F1F4FB",
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "onelogin-1",
    transform: "translate(5, 5)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#1F1F1F",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.0481928,8 L9.45421687,8 C9.20349741,8.00031036 9.00033186,8.19031307 9,8.42478873 L9,10.3357746 C9.00033186,10.5702503 9.20349741,10.760253 9.45421687,10.7605634 L11.0481928,10.7605634 L11.0481928,15.5752113 C11.0485246,15.8096869 11.2516902,15.9996896 11.5024096,16 L13.5457831,16 C13.7965026,15.9996896 13.9996681,15.8096869 14,15.5752113 L14,8.42478873 C13.9996681,8.19031307 13.7965026,8.00031036 13.5457831,8 L11.0481928,8 Z",
    id: "Path",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneLogin);
export default __webpack_public_path__ + "static/media/OneLogin.ea5b0c7c9aaf21e6857ceacf54353f74.svg";
export { ForwardRef as ReactComponent };